export default __webpack_public_path__ + "assets/static/data/blog-data.42bf7937236b7da7f316aa20cf479950.json";